
























// @ is an alias to /src
import {Component, Watch, Mixins} from "vue-property-decorator";
import MovingList from "@/components/contract-moving/movingList.vue";
import StepApplicationAcceptance from "@/components/contract-moving/step/stepApplicationAcceptance.vue";
import StepSchedule from "@/components/contract-moving/step/stepSchedule.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import { namespace } from "vuex-class";
import ContractMoveOut, { CONTRACT_STEP, ROLE_BY_STEP } from "@/model/contractMoveOut";
import contractMoveOutApi from "@/api/contractMoveOutApi";
import qNotify from "@/common/qNotify";
import Company from "@/model/company";
import User from "@/model/user";
import StepSignature from "@/components/contract-moving/step/stepSignature.vue";
import StepCorrectCheckList from "@/components/contract-moving/step/stepCorrectCheckList.vue";
import StepReSignature from "@/components/contract-moving/step/stepReSignature.vue";
import StepCompleteCheckList from "@/components/contract-moving/step/stepCompleteCheckList.vue";
import StepRequestRepair from "@/components/contract-moving/step/stepRequestRepair.vue";
import StepReviewRequestRepair from "@/components/contract-moving/step/stepReviewRequestRepair.vue";
import StepCreateReportRepair from "@/components/contract-moving/step/stepCreateReportRepair.vue";
import StepCompleteReportRepair from "@/components/contract-moving/step/stepCompleteReportRepair.vue";
import Authority from "@/common/mixins/authority";
const moveOutStore = namespace("MoveOut");
const authStore = namespace("Auth");
const masterStore = namespace("Master");
@Component({
  name: "ContractMovingListPage",
  components: {
    MovingList,
    StepApplicationAcceptance,
    StepSchedule,
    StepCheckList,
    StepSignature,
    StepCorrectCheckList,
    StepReSignature,
    StepCompleteCheckList,
    StepRequestRepair,
    StepReviewRequestRepair,
    StepCreateReportRepair,
    StepCompleteReportRepair,
  },
})
export default class ContractMovingListPage extends Mixins(Authority) {
  @moveOutStore.Action
  setMoveOut!: (moveOut: ContractMoveOut) => void;
  @authStore.Getter
  getCurrentyCompany!: Company;
  @authStore.Getter
  getUserLogging!: User;

  @masterStore.Action
  fetchAll!: () => Promise<any>;

  public loaded = false;
  public currentStep = 0;

  public mappingStep = {
    [CONTRACT_STEP.STEP_ACCEPTED]: "StepApplicationAcceptance",
    [CONTRACT_STEP.STEP_SCHEDULE]: "StepSchedule",
    [CONTRACT_STEP.STEP_CHECKLIST]: "StepCheckList",
    [CONTRACT_STEP.STEP_SIGNATURE]: "StepSignature",
    [CONTRACT_STEP.STEP_CORRECT_CHECK_LIST]: "StepCorrectCheckList",
    [CONTRACT_STEP.STEP_RE_SIGNATURE]: "StepReSignature",
    [CONTRACT_STEP.STEP_COMPLETE_CHECK_LIST]: "StepCompleteCheckList",
    [CONTRACT_STEP.STEP_REQUEST_REPAIR]: "StepRequestRepair",
    [CONTRACT_STEP.STEP_REVIEW_REQUEST_REPAIR]: "StepReviewRequestRepair",
    [CONTRACT_STEP.STEP_CREATE_REPORT_REPAIR]: "StepCreateReportRepair",
    [CONTRACT_STEP.STEP_COMPLETE_REPORT_REPAIR]: "StepCompleteReportRepair",
  };
  async mounted() {
    await this.fetchAll();
    await this.getDetail();
  }

  @Watch("$route", { immediate: true, deep: true })
  changeRouter() {
    const { step } = this.$router.currentRoute.query;
    if (step) {
      this.getDetail();
    }
  }

  get moveOutId() {
    return this.$router.currentRoute.params.id;
  }

  get currentComponent() {
    return this.mappingStep[this.currentStep];
  }

  public async getDetail() {
    const result = await contractMoveOutApi.show(this.moveOutId);
    if (result.meta.status === 200) {
      this.currentStep = result.data.step;
      if (
        ROLE_BY_STEP[this.currentStep].length > 0 &&
        !ROLE_BY_STEP[this.currentStep].includes(
          this.getCurrentyCompany.pivot.role_id
        )
      ) {
        qNotify.error({
          text: `現在、「${this.getUserLogging.username}」さんがバトンを持っているため、詳細画面を開くことができません。
          自身にバトンが回ってくるまでお待ちください。`,
        });
        this.$router.push({
          name: "admin.contract-moving",
        });
      } else {
        const moveOutObject = new ContractMoveOut(result.data);
        if (moveOutObject.isTranfered) {
          qNotify.error({
            text: this.$t("data_was_transfered"),
          });
          this.$router.push({ name: "admin.contract-moving" });
        }
        this.setMoveOut(moveOutObject);
        this.loaded = true;
      }
    }
  }

  public activeFollow(index, next = null) {
    return this.currentStep >= index || (next && this.currentStep >= next)
      ? "on"
      : "";
  }
}
